import {AbstractDTO} from '../abstract';
import {FormField} from './field';
import {FormFieldFactory} from './field-factory';
import {FieldControl} from "@signature-it/ngx-generic/enums";
import {NgxComponentField} from "./ngx-component";
import {RuleDTO} from "./rule";

export class FormStepDTO extends AbstractDTO {

    id: number;
    label: string;
    layout: string;
    saveAsDraft: boolean;
	hideFromStepperHeader: boolean;
    fields: FormField[];
    steps: FormStepDTO[];
	dependRules: RuleDTO[];
	hidden: boolean = false;
	deleteAnswersOnDependFailure: boolean;
	hideNextButton: boolean;
	hideBackButton: boolean;
	nextButtonLabel: string;
	backButtonLabel: string;
	hideSaveButton: boolean;
	stepClass: string;
	cngFields: cngField[] = [];

    constructor(attributes?: Object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = attributes['id'];
        this.label = attributes['label'] || '';
		this.layout = attributes['layout'] || '';
		this.saveAsDraft = attributes['saveAsDraft'] || false;
		this.hideFromStepperHeader = attributes['hideFromStepperHeader'] || false;
		this.deleteAnswersOnDependFailure = attributes['deleteAnswersOnDependFailure'] || false;
		this.hideNextButton = attributes['hideNextButton'] || false;
		this.hideBackButton = attributes['hideBackButton'] || false;
		this.nextButtonLabel = attributes['nextButtonLabel'] || '';
		this.backButtonLabel = attributes['backButtonLabel'] || '';
		this.hideSaveButton = attributes['hideSaveButton'] || false;
		this.stepClass = attributes['stepClass'] || '';
		if(attributes['dependRules']) {
			this.dependRules = RuleDTO.createFromArray(attributes['dependRules']);
		}
        let formFields: FormField[] = [];
        if(attributes['fields']) {
			attributes['fields'].forEach(field => {
				field.parentStepHasDependRule = this.dependRules && this.dependRules.length > 0;
				const f = FormFieldFactory.create(field);
				formFields.push(f);
				if(f.controlType == FieldControl.NGX_COMPONENT) {
					const g = <NgxComponentField>f;
					formFields = [...formFields, ...g.getFieldList()];
				}
			}, formFields);
			this.fields = formFields;
		}
		if(attributes['steps']) {
			this.hideNextButton = true;
			this.steps = FormStepDTO.createFromArray(attributes['steps']);
		}
		if(attributes['cngFields']) {
        	this.cngFields = cngField.createFromArray(attributes['cngFields']);
		}
    }

    setValues(values, force: boolean = false) {
    	if(this.fields) {
			this.fields.forEach(field => {
				field.setValue(values[field.key], force);
			});
		}
        if(this.steps) {
			this.steps.forEach(step => {
				step.setValues(values, force);
			});
		}
    }

    cngFieldsAsAns() {
    	let ans = {};
    	this.cngFields.forEach((field: cngField) => {
			ans[field.key] = field.value;
		});
    	return ans;
	}

}

export class cngField extends AbstractDTO {
	key: string;
	value: string;

	constructor(attributes?: Object) {
		super(attributes);
		attributes = attributes ? attributes : {};
		this.key = attributes['key'] || '';
		this.value = attributes['value'] || '';
	}
}
